import { Box, Typography } from '@mui/material';
import DotDivider from 'components/shared/DotDivider';
import Section from 'components/shared/Section';
import StageChip from 'components/shared/StageChip';
import { useAppSelector } from 'store/hooks';
import zeplinColor from 'theme/Color';
import { Utilities } from 'utilities/utilities';
import styles from './styles.module.css';
import { useFetchStageHistory } from './useFetchStageHistory';

const StageHistory = () => {
  const { dealId } = useAppSelector((state) => state.deals.deal);
  const { data, loading } = useFetchStageHistory(dealId);

  return (
    <Section title='Stage History'>
      <Box sx={{ maxHeight: '400px', overflowY: 'scroll', overflowX: 'hidden' }}>
        {loading ? (
          'Loading...'
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              height: '100%',
            }}
            className={styles['timeline-items']}
          >
            {data.map((item: any) => (
              <Box
                key={item.enteredAt}
                sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}
                className={styles['timeline-item']}
              >
                <Box
                  sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                >
                  <Typography variant='responsiveBody3'>{item.movedBy}</Typography>
                  <DotDivider color={zeplinColor.Neutral8} />
                  <Typography variant='responsiveBody3'>
                    {Utilities.formatDate(item.enteredAt)}
                  </Typography>
                </Box>
                <Box>
                  <StageChip dealType={item.stageName} />
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Section>
  );
};

export default StageHistory;
